import React from "react";
import Helmet from "react-helmet";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import Query from "./Query";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const SEO = React.memo((props) => {
  const { match } = props;
  const { path } = match;
  const { seo } = props;

  console.log('seo value', seo)



  if (seo) {
    return (
      <Helmet>
        <title>{seo.pageTitle}</title>
        <meta name="description" content={seo.pageDescription} />
        <meta name="keywords" content={seo.pageKeywords} />
      </Helmet>
    );
  }

  // if (path === "/consultation") {
  //   return <></>
  // } else {
  //   return (
  //     <Query
  //       url={`${BASE_URL}/api/pageSeo?url=${path}`}
  //       noRenderOnError
  //     >
  //       {({ data }) => {
  //         console.log(data);
  //         if (data)
  //           return (
  //             <Helmet>
  //               <title>{data.pageTitle}</title>
  //               <meta name="description" content={data.pageDescription} />
  //               <meta name="keywords" content={data.pageKeywords} />
  //             </Helmet>
  //           );
  //         return null;
  //       }}
  //     </Query>
  //   );

  // }
  return (
    <Query
      url={`${BASE_URL}/api/pageSeo?url=${path}`}
      noRenderOnError
    >
      {({ data }) => {
        console.log(data);
        if (data)
          return (
            <Helmet>
              <title>{data.pageTitle}</title>
              <meta name="description" content={data.pageDescription} />
              <meta name="keywords" content={data.pageKeywords} />
            </Helmet>
          );
        return null;
      }}
    </Query>
  );
});

SEO.propTypes = {
  seo: PropTypes.shape({
    pageTitle: PropTypes.string,
    pageDescription: PropTypes.string,
    pageKeywords: PropTypes.string,
  }),
};

SEO.defaultProps = {
  seo: null,
};

export default withRouter(SEO);
